import React from "react";

import ClientDashboardV2 from "./ClientDashboardV2";

export default function ClientTodayDashboardV3() {
  React.useEffect(() => {
    const previousTitle = document.title;
    document.title = "Бюро Души — Сегодня";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return <ClientDashboardV2 />;
}
